module.exports = __webpack_public_path__ + "img/trade-icon-5.2eeccd16.svg";